module.exports = __webpack_public_path__ + "files/e6ee879074fc875fd6aa72fa8cbdbdb5.png";